// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  padding: 0px 8px;
  background-color: var(--color-gray);
  width: fit-content;
  cursor: default;
  user-select: none;
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
  .tag {
    padding: 0px 6px;
    border-radius: 3px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Tag/Tag.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":[".tag {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 4px;\n  padding: 0px 8px;\n  background-color: var(--color-gray);\n  width: fit-content;\n  cursor: default;\n  user-select: none;\n}\n\n/* Mobile responsive adjustments */\n@media (max-width: 768px) {\n  .tag {\n    padding: 0px 6px;\n    border-radius: 3px;\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
